<template>
  <div class="wrapper">
    <PageVisibility @documentInactive="onDocumentInactive" @documentActive="onDocumentActive"></PageVisibility>
    <notifications></notifications>
    <side-bar>
      <template slot-scope="props" slot="links">
        <!-- <sidebar-item
          :link="{
            name: 'Dashboard',
            icon: 'ni ni-shop',
            path: '/dashboard'
          }"
        >
          <sidebar-item :link="{ name: 'Dashboard',  }"></sidebar-item>
        </sidebar-item> -->
        <sidebar-item v-for="(i, index) in navItems[userGroup]" :key="index"
          :link="{
            name: i.name,
            icon: 'fa ' + i.icon,
            path: i.path
          }"
        >
          <sidebar-item v-for="(n, nIndex) in i.nested" :key="nIndex" :link="{name: n.name, path: n.path}"></sidebar-item>
        </sidebar-item>
      </template>
    </side-bar>
    <div class="main-content">
      <dashboard-navbar></dashboard-navbar>

      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
      </div>
      <!-- <content-footer v-if="!$route.meta.hideFooter"></content-footer> -->
    </div>
  </div>
</template>

<script>
/* eslint-disable no-new */
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';
import PageVisibility from '../../components/PageVisibility';

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import DashboardNavbar from './DashboardNavbar.vue';
import ContentFooter from './ContentFooter.vue';
import DashboardContent from '../Layout/Content.vue';
import { FadeTransition } from 'vue2-transitions';

import AuthService from '../../services/AuthService'
import UserStore from '../../services/UserStore';

export default {

  components: {
    DashboardNavbar,
    ContentFooter,
    DashboardContent,
    FadeTransition,
    PageVisibility
  },

  data() {
    return {
      sessionExpired: false,
      navItems: {
        admins: [
          {
            name: 'Admin Dashboard',
            icon: 'fa fa-columns',
            path: '/admin/dashboard'
          },
          {
            name: 'Retailer Management',
            icon: 'fa fa-store',
            path: '',
            nested: [
              {
                name: 'Overview',
                path: '/admin/retailer/overview'
              },
              {
                name: 'Add/Edit',
                path: '/admin/retailer/onboarding'
              }
            ] 
          },
          {
            name: 'Charity Management',
            icon: 'fa fa-ribbon',
            path: '',
            nested: [
              {
                name: 'Overview',
                path: '/admin/charity/overview'
              },
              {
                name: 'Add/Edit',
                path: '/admin/charity/onboarding'
              }
            ] 
          },
          {
            name: 'Drop Management',
            icon: 'fa fa-shopping-bag',
            path: '',
            nested: [
              {
                name: 'Add Drop',
                path: '/admin/drop/create'
              }
            ] 
          },
          {
            name: 'UserManagement',
            icon: 'fa fa-users',
            path: '/admin/users',
          },
          {
            name: 'Drop Analytics',
            icon: 'fa fa-chart-bar',
            path: '',
            nested: [
              {
                name: 'Operations',
                path: '/admin/drop-analytics/operations'
              },
              {
                name: 'Service Improvements',
                path: '/admin/drop-analytics/service-improvements'
              },
            ] 
          }
        ],
        retailerLead: [
          {
            name: 'Retailer Lead Dashboard',
            icon: 'fa fa-columns',
            path: '/lead-retailer/dashboard'
          },
          {
            name: 'Chain Management',
            icon: 'fa fa-project-diagram',
            path: '/lead-retailer/chain-management'
          },
          {
            name: 'Branch Management',
            icon: 'fa fa-store',
            path: '/lead-retailer/branch-management'
          },
          {
            name: 'Connected Charities',
            icon: 'fa fa-ribbon',
            path: '/lead-retailer/connected-charities'
          },
        ],
        retailers: [
          {
            name: 'Retailer Dashboard',
            icon: 'fa fa-columns',
            path: '/retailer/dashboard'
          },
          {
            name: 'Your Branch',
            icon: 'fa fa-store',
            path: '/retailer/your-branch'
          },
          {
            name: 'Connected Charities',
            icon: 'fa fa-ribbon',
            path: '/retailer/connected-charities'
          },
        ],
        charities: [
          {
            name: 'Charity Dashboard',
            icon: 'fa fa-columns',
            path: '/charity/dashboard'
          },
          {
            name: 'Your Branch',
            icon: 'fa fa-ribbon',
            path: '/charity/your-branch'
          },
          {
            name: 'Connected Retailers',
            icon: 'fa fa-store',
            path: '/charity/connected-retailers'
          },
        ],
      },
      userGroup: UserStore.userData.group || null
    }
  },

  methods: {
    initScrollbar() {
      let docClasses = document.body.classList;
      let isWindows = navigator.platform.startsWith('Win');
      
      if (isWindows) {
        // if we are on windows OS we activate the perfectScrollbar function
        initScrollbar('scrollbar-inner');

        docClasses.add('perfect-scrollbar-on');
      }
      else {
        docClasses.add('perfect-scrollbar-off');
      }
    },

    onDocumentInactive() {
      // console.log('This document is inactive');
    },

    async onDocumentActive() {
      const activeSession = await AuthService.checkWeb();
      
      if(!activeSession && !this.sessionExpired) {
        this.sessionExpired = true;
        alert('Your session has expired due to inactivity, you have been logged out.')
        UserStore.clearUserData();
        this.$router.push('/auth/login');
      }
    }
  }

};
</script>
